import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader, Row, Col, Button } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
// Componentes
import ColorPicker from "../../components/ColorPicker/ColorPicker";
// service
import { createStatusRsvp } from "../../utils/services/statusRsvp";
import ButtonSpinner from "../../components/Buttons/ButtonSpinner";

export default function ModalNewStatusRsvp(props) {
  const { isOpen, toggle, getListStatusRsvp, contractId } = props;

  // State de dados do formulário
  const [descriptionError, setDescriptionError] = useState("");
  const [backgroundColor, setBackgroundColor] = useState("#ffffff");
  const [textColor, setTextColor] = useState("#000000");

  // State de modais/alertas
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertError, setAlertError] = useState("");

  // State de loading
  const [isLoading, setIsloading] = useState(false);

  // Valida os campos obrigatórios antes de enviar
  function verifyForm(e) {
    if (!e.target[0].value) {
      setDescriptionError("O campo Status é obrigatório");
      return;
    }
    setDescriptionError("");
    submitForm(e);
  }

  // Envia o payload para o backend (inclui contractId — o backend usa
  // pra vincular o status ao contrato do usuário logado).
  async function submitForm(e) {
    const data = {
      description: e.target[0].value,
      enabled: true,
      contractId,
      backgroundColor,
      textColor,
    };
    setIsloading(true);
    const res = await createStatusRsvp(data);
    setIsloading(false);
    if (res && res.status >= 200 && res.status < 300) {
      setAlertSuccess(true);
      return;
    }
    // Backend retorna { message: "DESCRIPTION_ALREADY_EXISTS" } quando
    // já existe um status com a mesma descrição pra esse contrato.
    if (res?.data?.message === "DESCRIPTION_ALREADY_EXISTS") {
      setAlertError("Já existe um status com essa descrição.");
      return;
    }
    setAlertError("Não foi possível criar o status. Tente novamente.");
  }

  return (
    <>
      {alertSuccess && (
        <SweetAlert
          success
          title="Criado"
          onConfirm={() => {
            getListStatusRsvp();
            toggle();
          }}
        >
          Status RSVP criado com sucesso!
        </SweetAlert>
      )}

      {alertError && (
        <SweetAlert
          warning
          title="Atenção"
          confirmBtnText="Ok"
          confirmBtnBsStyle="success"
          onConfirm={() => setAlertError("")}
        >
          {alertError}
        </SweetAlert>
      )}

      <Modal isOpen={isOpen} centered autoFocus>
        <ModalHeader toggle={toggle}>Novo Status RSVP</ModalHeader>
        <ModalBody>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              verifyForm(e);
            }}
          >
            <Row>
              <Col lg={12}>
                <label className="form-label">Status*</label>
                <input className="form-control" type="text" />

                {descriptionError && (
                  <span style={{ color: "red" }}>{descriptionError}</span>
                )}
              </Col>
            </Row>

            <Row style={{ marginTop: 15 }}>
              <Col md={6}>
                <ColorPicker
                  classOfContainer="status-rsvp-new-bg-pickr"
                  labelText="Cor de Fundo"
                  setStateFunc={setBackgroundColor}
                  defaultColor={backgroundColor}
                />
              </Col>
              <Col md={6}>
                <ColorPicker
                  classOfContainer="status-rsvp-new-text-pickr"
                  labelText="Cor do Texto"
                  setStateFunc={setTextColor}
                  defaultColor={textColor}
                />
              </Col>
            </Row>

            <Row
              style={{
                width: "100%",
                margin: "auto",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 20,
              }}
            >
              <Button
                color="danger"
                className="btn btn-danger waves-effect waves-light"
                style={{ width: 80, marginRight: "1rem" }}
                onClick={() => toggle()}
              >
                Fechar
              </Button>
              <ButtonSpinner isLoading={isLoading} title="Salvar" />
            </Row>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
}
